import React from 'react';
import { BOND_NO_TRUNCATED_MESSAGE } from '../Form/addressFieldConfig';

export function BondNoTruncationNotice({ show }) {
	if (!show) return null;

	return (
		<div className="alert alert-warning small py-2 mt-2 mb-0" role="status">
			{BOND_NO_TRUNCATED_MESSAGE}
		</div>
	);
}
